import { Component, computed, OnInit, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppInfo } from '../../../global/environment';
import { OrbitUtils } from '../../../global/orbit/orbit-utils';
import { ButtonComponent } from '../../../shared/components/button/button.component';
import { TelephoneLinkComponent } from '../../../shared/components/telephone-link/telephone-link.component';
import { GAService } from '../book-claim/services/ga-tags.service';
import { OrbitFormClaimService } from '../book-claim/services/orbit-form-claim.service';

@Component({
  selector: 'app-error-page',
  imports: [ButtonComponent, TelephoneLinkComponent],
  templateUrl: './error-page.component.html',
  styleUrl: './error-page.component.scss',
})
export class ErrorPageComponent implements OnInit {
  planNumber = signal<string | undefined>(undefined);
  protected viewModel = computed(() => {
    const bookingOEM = this.orbitFormClaimService.state.claimData?.mandatoryData?.bookingOEM;
    const brand = this.orbitFormClaimService.state.claimData?.bundle?.manufacturer;

    const { status, message } = this.orbitFormClaimService.state.formError?.error || {};
    const bookingError = `${status ?? ''}`.startsWith('RD');

    const mappedPhoneNumber =
      this.bookingOEMPhoneNumbers[(bookingOEM ?? '').toUpperCase()] ??
      this.bookingOEMPhoneNumbers[(brand ?? '').toUpperCase()];

    return {
      errors: this.orbitFormClaimService.state.formError,
      planNumber: this.planNumber(),
      firstMessage:
        bookingError && mappedPhoneNumber
          ? `Please give ${bookingOEM?.toUpperCase()} a call to arrange your repair on:`
          : 'Please give us a call for help with your booking:',
      phoneNumber: bookingError && mappedPhoneNumber ? mappedPhoneNumber : '0333 000 9703',
      repairsPageUrl: `${AppInfo.Environment.claimsURL}/my-plans/${this.planNumber()}/claims`,
      errorCode:
        status && message
          ? `${status} ${message}`
          : (this.statusMap[`${this.orbitFormClaimService.state.formError?.status}`] ?? 'Unknown error'),
      bookingOEM,
    };
  });

  get vm() {
    return this.viewModel();
  }

  bookingOEMPhoneNumbers: Record<string, string> = {
    BAXI: '0344 335 6556',
    // WHP
    WHIRLPOOL: '0344 822 7227',
    BEKO: '0344 822 7227',
    // Haier brands
    HAIER: '0344 499 5599',
    'HOOVER CANDY': '0344 499 5599',
    HOOVER: '0344 499 5599',
    CANDY: '0344 499 5599',
  };

  statusMap: Record<string, string> = {
    400: '400 Something went wrong',
    500: '500 Unknown issue',
  };

  constructor(
    private readonly route: ActivatedRoute,
    private router: Router,
    private readonly orbitFormClaimService: OrbitFormClaimService,
    private readonly gaService: GAService
  ) {}

  ngOnInit() {
    if (!this.vm.bookingOEM) {
      // LiveChat.showLiveChatLauncher();
    }
    this.planNumber.set(this.route.snapshot.params['planNumber']);
    OrbitUtils.initialise(this.router, this.planNumber()!, this.orbitFormClaimService);
    this.gaService.sendGATag(this.gaService.GA_ERROR.PAGE_LOAD());
    this.gaService.sendGATag({
      ...this.gaService.GA_ERROR.EVENT(),
      eventLabel: this.vm.errorCode,
    });
    if (!this.vm.errors) {
      console.error('No errors found in the Orbit Form Claim Service');
      OrbitUtils.sendUserBackToMMRPage();
      return;
    }
  }
}
